import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const LiveDisplayDate = ({ format = "YYYY-MM-DD HH:mm:ss" }) => {
  const [localTime, setLocalTime] = useState(moment());
  const [utcTime, setUtcTime] = useState(moment.utc());

  useEffect(() => {
    const timer = setInterval(() => {
      setLocalTime(moment());
      setUtcTime(moment.utc());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Tooltip
      title={
        <>
          <div>Local: {localTime.format(format)}</div>
          <div>UTC:   {utcTime.format(format)}</div>
        </>
      }
      arrow
    >
      <IconButton size="small">
        <AccessTimeIcon sx={{ fontSize: '1.8rem' }} />
      </IconButton>
    </Tooltip>
  );
};

export default LiveDisplayDate;
